import React from 'react';

import { SingePathIcon } from './SinglePathIcon';

export const Minus = () => (
    <SingePathIcon
        path="M1 1H9"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
    />
);

Minus.viewBox = `0 0 10 2`;
